@let errorValue = error$ | async;
@let loadingValue = loading$ | async;
@let listingValue = listing$ | async;
<div class="top-box mx-3" [class.embedded]="embedded">
    <local-filtering-search [options]="documentSearchOptionGroups" class="{{ searchclasses }}" [search]="initialSearch" [requiredFilters]="requiredFilters" [saveSearches]="true" [embedded]="embedded"
        [saveSearchesText]="saveSearchesText" [area]="contentSet!" [documentsStore]="documentsStore"></local-filtering-search>
    @if (listingValue; as listing) {

    @if (listing.present > 0) {
    <div class="results-header">
        @if (embedded) {
            @if (docketUpdating !== '') {
                <button class="btn btn-outline-bankruptcydata btn-sm float-end" disabled>
                    <div class="p-0 spinner-border spinner-border-sm">
                    </div>
                    {{docketUpdating}}
                </button>
            } @else {
                <button  (click)="updateDocket()" class="btn btn-outline-bankruptcydata btn-sm float-end update-docket"><i-bs [name]="iconNames.ArrowClockwise"></i-bs> Update </button>
            }
        }
        <span>
            Results 1 to {{listing.present | number}} of {{listing.total | number}}
        </span>
    </div>
    }

    }
</div>
@if (!embedded ) {

<ng-scrollbar class="ngr-scrollbar"  visibility="visible" externalViewport>
    <div infiniteScroll [scrollWindow]="false" scrollViewport (scrolled)="loadMoreDocuments()">
        <table class="table table-hover sticky-header" [class.embedded]="embedded">
            <thead>
                <tr>
                    <th class="text-end"><ng-container *ngTemplateOutlet="tableColumnHeading; context : {searchOption: searchResultsColumnDefinition['date']}"></ng-container></th>
                    @if (embedded) {
                    <th><ng-container *ngTemplateOutlet="tableColumnHeading; context : {searchOption: searchResultsColumnDefinition['docketid']}"></ng-container></th>
                    }
                    @if (showCaseInfo) {
                    <th><ng-container *ngTemplateOutlet="tableColumnHeading; context : {searchOption: searchResultsColumnDefinition['case_name']}"></ng-container></th>
                    }
                    @if (showCaseInfo) {
                    <th class="text-nowrap">Case Number</th>
                    }
                    <th>Description</th>
                    <th><ng-container *ngTemplateOutlet="tableColumnHeading; context : {searchOption: searchResultsColumnDefinition['documenttypes']}"></ng-container></th>
                    <th colspan="2">Parts</th>
                </tr>
            </thead>
            <tbody class="table-group-divider">
                <ng-template *ngTemplateOutlet="documentsTableBody"></ng-template>
                @if ((loadingValue); as loading) {
                <tr>
                    <td colspan="100">
                        <div class="progress-container" style="height: 64px;">
                            <ngb-progressbar [value]="100" [striped]="true" [animated]="true"></ngb-progressbar>
                        </div>
                    </td>
                </tr>
                }
                @if ((errorValue)) {
                <tr>
                    <td colspan="100">
                        <div class="alert alert-danger" role="alert">
                            Error loading content -- please try again
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</ng-scrollbar>

} @else {

<table class="table sticky-header table-hover" [class.embedded]="embedded">
    <thead>
        <tr>
            <th class="text-end"><ng-container *ngTemplateOutlet="tableColumnHeading; context : {searchOption: searchResultsColumnDefinition['date']}"></ng-container></th>
            @if (embedded) {
            <th><ng-container *ngTemplateOutlet="tableColumnHeading; context : {searchOption: searchResultsColumnDefinition['docketid']}"></ng-container></th>
            }
            @if (showCaseInfo) {
            <th><ng-container *ngTemplateOutlet="tableColumnHeading; context : {searchOption: searchResultsColumnDefinition['case_name']}"></ng-container></th>
            }
            @if (showCaseInfo) {
            <th class="text-nowrap">Case Number</th>
            }
            <th>Description</th>
            <th><ng-container *ngTemplateOutlet="tableColumnHeading; context : {searchOption: searchResultsColumnDefinition['documenttypes']}"></ng-container></th>
            <th colspan="2">Parts</th>
        </tr>
    </thead>
    <tbody class="table-group-divider">
        <ng-template *ngTemplateOutlet="documentsTableBody"></ng-template>
    </tbody>
</table>
@if ((errorValue)) {

<div class="row opacity-100">
    <div class="col">
        <div class="alert alert-danger" role="alert">
            Error loading content -- please try again
        </div>
    </div>
</div>

}
@if ((loadingValue); as loading) {

@if (loading) {
<div class="container">
    <div class="row">
        <div class="col">
            <div class="m-4">
                <ngb-progressbar [value]="100" [striped]="true" [animated]="true"></ngb-progressbar>
            </div>
        </div>
    </div>
</div>
}

} @else {

@if (listingValue; as listing) {

@if (listing.present < listing.total) { <div (click)="loadMoreDocuments()" class="position-relative py-2 mb-5">
    <button class="btn btn-gradient position-absolute start-50 translate-middle top-100 ">Load more... </button>
    </div>
    }

    }

    }

    }


    <ng-template #documentsTableBody>
        @if (documents$ | async; as documents) {


        @if (documents.length === 0 && !(loadingValue)) {
        <tr>
            <td colspan="100">
                <div class="position-relative" style="height: 70vh;">
                    <div class="position-absolute top-50 start-50 translate-middle border border-primary h2 p-3 border-5 rounded-5">
                        No results found
                    </div>
                </div>
            </td>
        </tr>
        }
        @for (aDocument of documents; track aDocument) {

        <tr>
            <td class="text-nowrap">{{aDocument.date | date:'mediumDate':'+0000'}}</td>
            @if (embedded) {
            <td>{{aDocument.docketid}}</td>
            }
            @if (showCaseInfo) {
            <td><a routerLink="/situations/{{ aDocument.casedocumentinfo['articleID']}}" target="_blank">{{aDocument.case_name}} </a></td>
            }
            @if (showCaseInfo) {
            <td>{{aDocument.case_number}}</td>
            }
            <td [innerHTML]="aDocument.description"></td>
            <td>{{aDocument.documenttypes.join(',')}}</td>
            <td colspan="2">
                <app-document-links [item]="convertFormat(aDocument)"  (purchased)="reloadDocket($event, aDocument.id)"></app-document-links>
            </td>
        </tr>
        @if (aDocument.snippets) {
        <tr>
            <td colspan="10">
                <p [innerHTML]="aDocument.snippets"></p>
            </td>
        </tr>
        }

        }

        }
    </ng-template>

    <adobe-pdf-viewer></adobe-pdf-viewer>

    <app-input-dialog #updateDocketDialog title="Update Docket">
        <input-dialog-step button="">
            <form #updateDocketForm (ngSubmit)="checkPacerLogin()">
                <div class="row py-2">
                    <div class="col">
                        <p>To complete the purchase we need your PACER credentials. We do not store your PACER credentials.</p>
                        @if (pacerCredentialsWrong) {
                        <div class="alert alert-danger" role="alert">
                            Username and/or password incorrrect
                        </div>
                        }
                        <div class="form-floating mb-4">
                            <input type="text" class="form-control" id="pacerUsername" name="pacerUsername" required [class.is-invalid]="pacerUsernameRequired" [(ngModel)]="pacerUsername" (focus)="$any($event.target).select()" ngbAutofocus>
                            <label class="form-label" for="pacerUsername">Pacer Username</label>
                        </div>
                        <div class="invalid-feedback">
                            Username required
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-auto">
                        <div class="form-floating mb-4">
                            <input type="password" class="form-control" id="pacerPassword" name="pacerPassword" required [class.is-invalid]="pacerPasswordRequired" [(ngModel)]="pacerPassword" (focus)="$any($event.target).select()">
                            <label class="form-label" for="pacerPassword">Pacer Password</label>
                        </div>
                        <div class="invalid-feedback">
                            Password required
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-auto">
                        <div class="form-floating mb-4">
                            <input type="text" class="form-control" id="clientCode" name="clientCode" [(ngModel)]="clientCode" (focus)="$any($event.target).select()">
                            <label class="form-label" for="clientCode">Optional Client Code</label>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-auto">
                        @if (pacerLoginButtonEnabled) {
                        <button type="submit" class="btn btn-outline-bankruptcydata btn-block mb-3">Submit</button>
                        } @else {
                        <button class="btn btn-outline-bankruptcydata btn-block mb-3" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status"></span>
                        </button>

                        }
                    </div>
                </div>
            </form>
        </input-dialog-step>
    </app-input-dialog>

    <ng-template #tableColumnHeading let-option="searchOption">
        @if (search$ | async; as search) {

        @if (option.tableColumn.sortable) {
        <div class="column-sorter" [attr.data-sortid]="option.id" (click)="toggleOrder(search, option.id)">
            {{ option.name }}
            @if (option.id === search.order!.column) {

            @if (search.order!.direction == 'desc') {
            <i-bs [name]="iconNames.SortAlphaDownAlt"></i-bs>
            }
            @if (search.order!.direction == 'asc') {
            <i-bs [name]="iconNames.SortAlphaUpAlt"></i-bs>
            }

            }
        </div>
        } @else {

        <div class="w-100" (click)="$event.stopPropagation()">
            {{ option.name }}
        </div>

        }

        }
    </ng-template>